webpackJsonp([125885535567068],{

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsletterPage = function NewsletterPage() {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'component--centered mb bordered' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Want to be notified when I publish new tutorials and when I have something Important to say/ask?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Tutorials and Articles on Javascript, React, Express, GraphQL, MongoDB, Microservices, Serverless, Continuous Deployment and more.'
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'EMAIL', style: { cursor: 'pointer' } },
	        'Please enter your email address below.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'input', style: { marginTop: 10 } },
	        _react2.default.createElement(
	          'form',
	          { method: 'post', action: 'https://dhruvkumarjha.us17.list-manage.com/subscribe/post?u=489b7ba732e0457406dc20898&id=3c3df9a3d9', className: 'default flex', target: '_blank' },
	          _react2.default.createElement('input', { style: { width: '80%' }, type: 'text', name: 'EMAIL', id: 'EMAIL', placeholder: 'john.doe@gmail.com' }),
	          _react2.default.createElement(
	            'button',
	            { className: 'button button--green size--medium', type: 'submit' },
	            'Subscribe Me'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = NewsletterPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-newsletter-js-b7b4e116b3515c26a736.js